<h2 mat-dialog-title>{{ dialogData.mode }} Reseller</h2>

<form
  [formGroup]="formGroup"
  (ngSubmit)="submit(formGroup.value, dialogData, dialogRef)"
>
  @if (showApiMessage) {
  <ctx-alert [alertLevel]="apiMessage.alertLevel">{{
    apiMessage.text
  }}</ctx-alert>
  }
  <mat-dialog-content>
    <section class="flex flex-col gap-4">
      <!-- Name -->
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input
          autocomplete="off"
          type="text"
          formControlName="name"
          matInput
          required
        />
        <mat-error> {{ getControlError(formGroup, 'name') }}</mat-error>
      </mat-form-field>

      <!-- Email -->
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input
          autocomplete="off"
          type="email"
          formControlName="email"
          matInput
          required
        />
        <mat-error>{{ getControlError(formGroup, 'email') }}</mat-error>
        <mat-hint>Notification email of the reseller.</mat-hint>
      </mat-form-field>

      <!-- Description -->
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea
          rows="1"
          type="text"
          formControlName="description"
          matInput
          required
        ></textarea>
        <mat-error> {{ getControlError(formGroup, 'description') }}</mat-error>
      </mat-form-field>

      <!-- Allowed Users -->
      <mat-form-field>
        <mat-label>Allowed Users</mat-label>
        <input
          autocomplete="off"
          type="number"
          formControlName="allowedUsers"
          matInput
        />
        <mat-hint
          >Max number of users the reseller is allowed to create.
          {{ UNLIMITED_VALUE_MINUS_ONE }}</mat-hint
        >
        <mat-error>{{ getControlError(formGroup, 'allowedUsers') }}</mat-error>
      </mat-form-field>

      <!-- Allowed Organizations -->
      <mat-form-field>
        <mat-label>Allowed Organizations</mat-label>
        <input
          autocomplete="off"
          type="number"
          formControlName="allowedOrganizations"
          matInput
        />
        <mat-hint
          >Max number of organizations the reseller is allowed to create.
          {{ UNLIMITED_VALUE_MINUS_ONE }}</mat-hint
        >
        <mat-error>{{
          getControlError(formGroup, 'allowedOrganizations')
        }}</mat-error>
      </mat-form-field>
    </section>
  </mat-dialog-content>

  <!-- Buttons -->
  <mat-dialog-actions>
    <button
      matDialogClose
      ctx-button--secondary
      [disabled]="formStates.disabled"
    >
      Close
    </button>
    <button
      ctx-button--primary
      [disabled]="formStates.disabled"
      [loading]="formStates.submit"
      type="submit"
    >
      {{ dialogData.mode }}
    </button>
  </mat-dialog-actions>
</form>
